/// <reference path="../../app.definition.ts" />

import { Serializable } from "./Serializable";

export class CrProfile implements Serializable<CrProfile> {
    about: string;
    aboutAddedBy: number;
    subjectCareDetails: Array<any>;
    subjectId: number;

    deserialize(input: any) {
        input.about && (this.about = input.about);
        input.aboutAddedBy && (this.aboutAddedBy = input.aboutAddedBy);
        input.subjectCareDetails && (this.subjectCareDetails = input.subjectCareDetails);
        input.subjectId && (this.subjectId = input.subjectId);

        return this;
    }

    constructor() {
    }
}

